
import { ArrowRight, Heart } from "lucide-react";
import { Button } from "@/components/ui/button";
import { getAuthUrl } from "@/utils/redirectUtils";

const BeginnerCTA = () => {
  return (
    <section className="py-24 px-4 bg-blue-600 text-white">
      <div className="container mx-auto max-w-5xl text-center">
        <h2 className="text-3xl md:text-5xl font-bold mb-8">
          Ready to finally understand Google Ads?
        </h2>
        <p className="text-xl mb-12 max-w-3xl mx-auto opacity-90">
          Join thousands of beginners who have safely launched their first campaigns without wasting money or feeling overwhelmed.
        </p>
        
        <div className="flex justify-center mb-8">
          <Button 
            size="lg" 
            className="text-lg px-8 h-14 bg-white text-blue-600 hover:bg-blue-50"
            onClick={() => window.location.href = getAuthUrl()}
          >
            Start Your First Campaign <ArrowRight className="ml-2 h-5 w-5" />
          </Button>
        </div>
        
        <p className="text-sm opacity-90">
          Free plan forever. No credit card required.
        </p>
        
        <div className="flex items-center justify-center mt-12">
          <Heart className="text-red-300 mr-2 h-5 w-5" />
          <p className="text-sm opacity-90">
            Made with love for beginners who are tired of complicated Google Ads guides
          </p>
        </div>
      </div>
    </section>
  );
};

export default BeginnerCTA;
